import axios from 'axios';
import moment from 'moment';
import { AppConfig, JWT } from '../config';
import { resolveWarrantyType } from '../lib/warrantyType';
import { store } from '../store';
import { AlertAction } from './AlertAction';
import { Translate as t } from '../config/Translate';
import { ProductConstant } from './constants/ProductConstant';
import { ProgramConstant } from './constants/ProgramConstant';
import { RayDataAction } from './RayDataAction';

const GetStatistics = (currentPage, listCountPerPage, filter) => async (dispatch) => {
	dispatch({ type: ProductConstant.LOADING });
	try {
		const data = { type: 'get', data: { currentPage, listCountPerPage, filter } };

		const ret = await axios.post(AppConfig.API_SERVER_PATH + "/statistics", data, JWT());

		if (ret.data.status === 'success') {
			dispatch({ type: ProductConstant.GET_STATISTICS, result: ret.data.data });
		} else {
			dispatch(AlertAction.Error(ret.data));
		}
	} catch (error) {
		dispatch(AlertAction.ErrorMsg("Failed to get statistics."));
	}
	dispatch({ type: ProductConstant.LOADED });
}

const SaveStatisticsFilter = (title, filterType, condition) => async (dispatch) => {
	dispatch({ type: ProductConstant.LOADING });
	try {
		const ret = await axios.post(AppConfig.API_SERVER_PATH + "/statistics", { type: 'save', data: { title, filterType, condition } }, JWT());

		if (ret.data.status === 'success') {
			dispatch(AlertAction.Success(t('common.message.success.saved')));
			dispatch({ type: ProductConstant.GET_SAVED_FILTERS, result: ret.data.data });
		} else {
			dispatch(AlertAction.Error(ret.data));
		}
	} catch (error) {
		dispatch(AlertAction.Error(error));
	}
	dispatch({ type: ProductConstant.LOADED });
}

const GetSavedFilters = () => async (dispatch) => {
	dispatch({ type: ProductConstant.LOADING });
	try {
		const ret = await axios.post(AppConfig.API_SERVER_PATH + "/statistics", { type: 'filterList' }, JWT());

		if (ret.data.status === 'success') {
			dispatch({ type: ProductConstant.GET_SAVED_FILTERS, result: ret.data.data });
		} else {
			dispatch(AlertAction.Error(ret.data));
		}
	} catch (error) {
		dispatch(AlertAction.ErrorMsg("Failed to get saved filters."));
	}
	dispatch({ type: ProductConstant.LOADED });
}

const DeleteSavedFilter = (id) => async (dispatch) => {
	dispatch({ type: ProductConstant.LOADING });
	try {
		const ret = await axios.post(AppConfig.API_SERVER_PATH + "/statistics", { type: 'delete', data: { id } }, JWT());

		if (ret.data.status === 'success') {
			dispatch(AlertAction.Success(t('common.message.deleted')));
			dispatch({ type: ProductConstant.GET_SAVED_FILTERS, result: ret.data.data });
		} else {
			dispatch(AlertAction.Error(ret.data));
		}
	} catch (error) {
		dispatch(AlertAction.Error(error));
	}
	dispatch({ type: ProductConstant.LOADED });
}

const GetProductAllStock = (filter, append = false) => async (dispatch) => {
	dispatch({ type: ProductConstant.LOADING });

	const showmodel = store.getState().ProgramReducer.showmodel;
	const data = showmodel[0] !== '' ?
		{ type: "getstock", data: {...filter, match : {...filter.match, model : { '$in' : showmodel }} } } :
		{ type: "getstock", data: filter}

	try {
		const ret = await axios.post(AppConfig.API_SERVER_PATH + '/product', data, JWT());
		const vtype = "Stock";
		if (ret.data.status == 'success') {
			dispatch({ type: ProductConstant.GET_PRODUCTLIST, result: ret.data.data, append, vtype });
			dispatch({
				type: ProgramConstant.SET_SEARCHSCREEN_TITLE,
				title: "Products",
				count: ret.data.data.totalcount
			});
		} else {
			dispatch(AlertAction.Error(ret.data));
		}
	} catch (error) {
		dispatch(AlertAction.ErrorMsg("Failed to get product stock list."));
	}
	dispatch({ type: ProductConstant.LOADED });
};

const GetProductAll = (filter, append = false) => async (dispatch) => {
	dispatch({ type: ProductConstant.LOADING });

	const showmodel = store.getState().ProgramReducer.showmodel;
	const data = showmodel[0] !== '' ?
		{ type: "get", data: {...filter, match : {...filter.match, model : { '$in' : showmodel }} } } :
		{ type: "get", data: filter}

	try {
		const ret = await axios.post(AppConfig.API_SERVER_PATH + '/productv2', data, JWT());
		const vtype = "All";
		if (ret.data.status == 'success') {
			dispatch({ type: ProductConstant.GET_PRODUCTLIST, result: ret.data.data, append, vtype });
			dispatch({
				type: ProgramConstant.SET_SEARCHSCREEN_TITLE,
				title: "Products",
				count: ret.data.data.totalcount
			});
		} else {
			dispatch(AlertAction.Error(ret.data));
		}
	} catch (error) {
		dispatch(AlertAction.ErrorMsg("Failed to get product list."));
	}
	dispatch({ type: ProductConstant.LOADED });
};

const GetProductAllV2 = (filter, append = false) => async (dispatch) => {
	dispatch({ type: ProductConstant.LOADING });

	const showmodel = store.getState().ProgramReducer.showmodel;
	const data = showmodel[0] !== '' ?
		{ type: "get", data: {...filter, match : {...filter.match, model : { '$in' : showmodel }} } } :
		{ type: "get", data: filter}

	try {
		const ret = await axios.post(AppConfig.API_SERVER_PATH + '/productv2', data, JWT());
		const vtype = "All";
		if (ret.data.status == 'success') {
			dispatch({ type: ProductConstant.GET_PRODUCTLIST, result: ret.data.data, append, vtype });
			dispatch({
				type: ProgramConstant.SET_SEARCHSCREEN_TITLE,
				title: "Products",
				count: ret.data.data.totalcount
			});
		} else {
			dispatch(AlertAction.Error(ret.data));
		}
	} catch (error) {
		dispatch(AlertAction.ErrorMsg("Failed to get product list."));
	}
	dispatch({ type: ProductConstant.LOADED });
};

const GetFavProductAll = (filter) => async (dispatch) => {
	dispatch({ type: ProductConstant.LOADING });
	const uData = JSON.parse(localStorage.getItem('user'));
	const data = {
		type: "get",
		data: { ...filter, match: { sn: { '$in': uData.favorites } } }
		//data : {...filter}
	}
	try {
		const ret = await axios.post(AppConfig.API_SERVER_PATH + '/product', data, JWT());
		if (ret.data.status == 'success') {
			dispatch({ type: ProductConstant.GET_FAV_PRODUCTLIST, result: ret.data.data });
		} else {
			dispatch(AlertAction.Error(ret.data));
		}
	} catch (error) {
		dispatch(AlertAction.ErrorMsg("Failed to get favorite product list."));
	}
	dispatch({ type: ProductConstant.LOADED });
};

// const GetErrorCount = (days) => async (dispatch) => {
// 	dispatch({ type: ProductConstant.ERR_LOADING });
// 	const daybefore = days > 0 ? moment.utc(moment().utc()).add(-1 * days, 'days').unix() * 1000 : 0;
// 	const data = {
// 		type: "geterrorcount",
// 		data:  daybefore
// 	}
// 	const ret = await axios.post(AppConfig.API_SERVER_PATH + '/product', data, JWT());
// 	if (ret.data.status == 'success') {
// 		dispatch({ type: ProgramConstant.SET_ERRORS, list: ret.data.data });
// 	} else {
// 		dispatch(AlertAction.Error(ret.data));
// 	}
// 	dispatch({ type: ProductConstant.ERR_LOADED });
// };

const GetErrorCount = async (days) => {
	try {
		const daybefore = days > 0 ? moment.utc(moment().utc()).add(-1 * days, 'days').unix() * 1000 : 0;
		const showmodel = store.getState().ProgramReducer.showmodel;
		const aggregate = [];
		aggregate.push({ '$unwind': '$errs' });
		if(showmodel[0] !== ''){
			aggregate.push({
				'$match' : {
					'model' : { '$in' : showmodel} ,
					'errs.closer': null,
					'errs.end': null,
					'errs.begin': { "$gte": daybefore == 0 ? 1065398400000 : daybefore },
					'installedDate': { '$gt': 1065398400000 }
				}
			});
		}else{
			aggregate.push({
				'$match' : {
					'errs.closer': null,
					'errs.end': null,
					'errs.begin': { "$gte": daybefore == 0 ? 1065398400000 : daybefore },
					'installedDate': { '$gt': 1065398400000 }
				}
			});
		}
		aggregate.push({
			'$project': {
				waranties: 0,
				autoDiagnoses: 0,
				alignments: 0,
				acquisitions: 0,
				cautions: 0,
				qcs: 0,
				histories: 0,
				sitehistories: 0,
			}
		});
		const data = {
			data : {
				type: "product",
				aggregate,
			}
		}
		const ret = await axios.post(AppConfig.API_SERVER_PATH + '/q', data, JWT());
		if (ret.data.status == 'success') {
			return ret.data.data;
		} else {
			AlertAction.Error(ret.data);
		}
	} catch (error) {
		console.error("GetErrorCount error:", error);
		return [];
	}
};

const GetAllErrorList = (filter, showtype, append) => async (dispatch) => {
	dispatch({ type: ProductConstant.ERR_LOADING });
	try {
		const showmodel = store.getState().ProgramReducer.showmodel;
		const data = showmodel[0] !== '' ?
			{ type: "getallerrorlists", data: {...filter, showtype: showtype, match : {...filter.match, model : { '$in' : showmodel }} } } :
			{ type: "getallerrorlists", data: { ...filter, showtype: showtype }}

		const ret = await axios.post(AppConfig.API_SERVER_PATH + '/product', data, JWT());

		if (ret.data.status == 'success') {
			dispatch({ type: ProductConstant.GET_ERRORS, result: ret.data.data, append });
			dispatch({
				type: ProgramConstant.SET_SEARCHSCREEN_TITLE,
				title: "Errors",
				count: ret.data.data.totalcount
			});
		} else {
			dispatch(AlertAction.Error(ret.data));
		}
	} catch (error) {
		dispatch(AlertAction.ErrorMsg("Failed to get error list."));
	}
	dispatch({ type: ProductConstant.ERR_LOADED });
};

const GetErrorList = (filter, append) => async (dispatch) => {
	dispatch({ type: ProductConstant.ERR_LOADING });
	try {
		const data = {
			type: "geterrorlists",
			data: { ...filter }
		}

		const ret = await axios.post(AppConfig.API_SERVER_PATH + '/product', data, JWT());
		if (ret.data.status == 'success') {
			dispatch({ type: ProductConstant.GET_ERRORS, result: ret.data.data, append });
			dispatch({
				type: ProgramConstant.SET_SEARCHSCREEN_TITLE,
				title: "Errors",
				count: ret.data.data.totalcount
			});
		} else {
			dispatch(AlertAction.Error(ret.data));
		}
	} catch (error) {
		dispatch(AlertAction.ErrorMsg("Failed to get error list."));
	}
	dispatch({ type: ProductConstant.ERR_LOADED });
};

const GetErrors = (filter, append) => async (dispatch) => {
	dispatch({ type: ProductConstant.ERR_LOADING });
	try {
		const data = {
			type: "geterrors",
			data: { ...filter }
		}

		const ret = await axios.post(AppConfig.API_SERVER_PATH + '/product', data, JWT());

		if (ret.data.status == 'success') {
			dispatch({ type: ProductConstant.GET_ERRORS, result: ret.data.data, append });
			dispatch({
				type: ProgramConstant.SET_SEARCHSCREEN_TITLE,
				title: "Errors",
				count: ret.data.data.totalcount
			});
		} else {
			dispatch(AlertAction.Error(ret.data));
		}
	} catch (error) {
		dispatch(AlertAction.ErrorMsg("Failed to get errors."));
	}
	dispatch({ type: ProductConstant.ERR_LOADED });
};

const GetProductLocal = async (sn) => {
	try {
		// BUG-225 (#443): sn 에 공백·#·% 등이 포함되면 원문 연결 URL 이 깨져 무음 null —
		// 특정 SN 국한 조회 실패의 잠재 원인이라 인코딩한다.
		const ret = await axios.get(AppConfig.API_SERVER_PATH + '/product/' + encodeURIComponent(sn), JWT());
		if (ret.data.status == 'success') {
			return ret.data.data
		}
	} catch (error) {
		console.error("GetProductLocal error:", error);
	}
	return null;
};

const GetProductOld = (sn, sninfo) => async (dispatch) => {
	dispatch({ type: ProductConstant.LOADING });
	try {
		const data = {
			type: "getold",
			data: {}
		}
		const ret = await axios.post(AppConfig.API_SERVER_PATH + '/product/' + sn, data, JWT());
		if (ret.data.status == 'success') {
			dispatch({ type: ProductConstant.GET_PRODUCT_OLD, product: ret.data.data, orisninfo: sninfo });
		} else {
			dispatch(AlertAction.Error(ret.data));
		}
	} catch (error) {
		dispatch(AlertAction.ErrorMsg("Failed to get product data."));
	}
	dispatch({ type: ProductConstant.LOADED });
};

const GetProduct = (sn, { quietNotFound = false } = {}) => async (dispatch) => {
	dispatch({ type: ProductConstant.LOADING });

	//await RayDataAction.SetWarranty(sn, "HQ", "CT");

	try {
		const ret = await axios.get(AppConfig.API_SERVER_PATH + '/product/' + sn, JWT());
		if (ret.data.status == 'success') {
			dispatch({ type: ProductConstant.GET_PRODUCT, product: ret.data.data });
		} else if (quietNotFound === true && ret.data?.errmsg === 'EP0009') {
			// EP0009 는 없음/권한 밖이며 처리 오류가 아님 — 호출 화면이 자체 안내를 그린다.
			console.warn('[guard] product not-found alert suppressed', {
				handler: 'ProductAction.GetProduct',
				targetSn: sn,
				reason: 'EP0009 not found or out of scope; screen shows its own notice',
			});
		} else {
			dispatch(AlertAction.Error(ret.data));
		}
	} catch (error) {
		dispatch(AlertAction.ErrorMsg("Failed to get product."));
	}
	dispatch({ type: ProductConstant.LOADED });
};


const GetProductAcq = (filter, sn) => async (dispatch) => {
	dispatch({ type: ProductConstant.LOADING });
	console.log("GetProductAcq : ===", filter);
	console.log("GetProductAcq snsnsnsn : ===", sn);
	try {
		const pageOffset = filter.itemperpage * (filter.page -1);

		const data = {
			"query" : "SELECT sn, confirm, modality, protocol, description, activationtime, startTime, timestamp FROM `rayteams.rayteams_device.rayscan_acq` where sn = '" + filter.sn + "' ORDER BY activationtime DESC LIMIT " + filter.itemperpage + " OFFSET " + pageOffset + " "
		}
		const ret = await axios.post(AppConfig.API_BIQ_PATH, data);

		dispatch({ type: ProductConstant.GET_PRODUCT_ACQ, sn: sn, acquisitions: ret.data.results });
	} catch (error) {
		dispatch(AlertAction.ErrorMsg("Failed to get product acquisitions."));
	}
	dispatch({ type: ProductConstant.LOADED });
};

const GetProductAcqChart = (sn) => async (dispatch) => {
	dispatch({ type: ProductConstant.LOADING });
	try {
		const oneWeekAgo = new Date().getTime() - 7 * 24 * 60 * 60 * 1000;
		const data = {
			"query" : "SELECT sn, confirm, modality, protocol, description, activationtime, startTime, timestamp FROM `rayteams.rayteams_device.rayscan_acq` where sn = '" + sn + "' and activationtime > " + oneWeekAgo + " ORDER BY activationtime DESC"
		}
		const ret = await axios.post(AppConfig.API_BIQ_PATH, data);

		console.log("GetProductAcqChart : ================================================", ret.data.results);

		dispatch({ type: ProductConstant.GET_PRODUCT_ACQ_CHART, sn: sn, acquisitions: ret.data.results });
	} catch (error) {
		dispatch(AlertAction.ErrorMsg("Failed to get product acquisition chart."));
	}
	dispatch({ type: ProductConstant.LOADED });
};

const GetProductDia = (filter, sn, append = false) => async (dispatch) => {
	dispatch({ type: ProductConstant.LOADING });
	try {
		const pageOffset = filter.itemperpage * (filter.page -1);
		const data = {
			"query" : "SELECT sn, timestamp, autodiagnoses FROM `rayteams.rayteams_device.rayscan_dia` where sn = '" + filter.sn + "' ORDER BY timestamp DESC LIMIT " + filter.itemperpage + " OFFSET " + pageOffset + " "
		}
		const ret = await axios.post(AppConfig.API_BIQ_PATH, data);

		const results = ret.data.results.map(x => {
			return JSON.parse(x.autodiagnoses)
		});

		dispatch({ type: ProductConstant.GET_PRODUCT_DIA, sn: sn, autodiagnoses: results, append: append });
	} catch (error) {
		dispatch(AlertAction.ErrorMsg("Failed to get product diagnostics."));
	}
	dispatch({ type: ProductConstant.LOADED });
};

const GetProductHistory = (filter, sn, append = false) => async (dispatch) => {
	dispatch({ type: ProductConstant.LOADING });
	try {
		const pageOffset = filter.itemperpage * (filter.page -1);
		const data = {
			"query" : "SELECT sn, timestamp, his FROM `rayteams.rayteams_device.rayscan_hist` where sn = '" + filter.sn + "' ORDER BY timestamp DESC LIMIT " + filter.itemperpage + " OFFSET " + pageOffset + " "
		}
		const ret = await axios.post(AppConfig.API_BIQ_PATH, data);

		const results = ret.data.results.map(x => {
			return JSON.parse(x.his)
		});

		dispatch({ type: ProductConstant.GET_PRODUCT_HISTORY, sn: sn, histories: results, append: append });
	} catch (error) {
		dispatch(AlertAction.ErrorMsg("Failed to get product history."));
	}
	dispatch({ type: ProductConstant.LOADED });
};


const UpdateProductWarranty = (sn, info) => async (dispatch) => {
	dispatch({ type: ProductConstant.LOADING });
	try {
		const data = {
			who: JSON.parse(localStorage.getItem('user')).adminid,
			type: 'updateAddWarranty',
			data: info,
		};
		const ret = await axios.post(AppConfig.API_SERVER_PATH + '/product/' + sn, data, JWT());
		if (ret.data.status == 'success') {
			dispatch(AlertAction.Success(t('common.message.success.saved')));
			dispatch({ type: ProductConstant.UPDATE_PRODUCTINFO, product: ret.data.data });
		} else {
			dispatch(AlertAction.Error(ret.data));
		}
	} catch (error) {
		dispatch(AlertAction.Error(error));
	}
	dispatch({ type: ProductConstant.LOADED });
};

const AddExtendedWarranty = (sn, data) => async (dispatch) => {
	try {
		const ret = await axios.post(AppConfig.API_SERVER_PATH + '/product/' + sn, {
			type: 'addExtendedWarranty',
			data
		}, JWT());

		// 방어: 성공 + product 바디가 있을 때만 안내·교체 (DeleteExtendedWarranty 와 동일 방어).
		if (ret?.data?.status === 'success' && ret?.data?.data) {
			dispatch(AlertAction.Success(t('common.message.success.saved')));
			dispatch({ type: ProductConstant.SET_PRODUCT_WARRANTY, product: ret.data.data });
		} else {
			dispatch(AlertAction.Error(ret?.data));
		}
	} catch (error) {
		dispatch(AlertAction.Error(error));
	}
}

// FEAT-046: 확장 워런티 개별 이력 항목 삭제(soft delete).
const DeleteExtendedWarranty = (sn, exId) => async (dispatch) => {
	try {
		const who = JSON.parse(localStorage.getItem('user'))?.adminid;
		const ret = await axios.post(AppConfig.API_SERVER_PATH + '/product/' + sn, {
			type: 'deleteExtendedWarranty',
			data: { exId, who }
		}, JWT());

		// 방어: 성공 + product 바디가 있을 때만 교체. 실패바디/미인식 응답으로 product=undefined 되어 상세 백지화·크래시 방지 (BE 선배포 지연·오류 fail-safe).
		if (ret?.data?.status === 'success' && ret?.data?.data) {
			dispatch(AlertAction.Success(t('common.message.deleted')));
			dispatch({ type: ProductConstant.SET_PRODUCT_WARRANTY, product: ret.data.data });
		} else {
			dispatch(AlertAction.Error(ret?.data));
		}
	} catch (error) {
		dispatch(AlertAction.Error(error));
	}
}

// FEAT-047: 확장 워런티 개별 이력 항목 수정.
const UpdateExtendedWarranty = (sn, exId, data) => async (dispatch) => {
	try {
		const who = JSON.parse(localStorage.getItem('user'))?.adminid;
		const ret = await axios.post(AppConfig.API_SERVER_PATH + '/product/' + sn, {
			type: 'updateExtendedWarranty',
			data: { ...data, exId, who }
		}, JWT());

		// 방어: 성공 + product 바디가 있을 때만 교체 (FEAT-046 DeleteExtendedWarranty 와 동일 방어).
		if (ret?.data?.status === 'success' && ret?.data?.data) {
			dispatch(AlertAction.Success(t('common.message.success.saved')));
			dispatch({ type: ProductConstant.SET_PRODUCT_WARRANTY, product: ret.data.data });
		} else {
			dispatch(AlertAction.Error(ret?.data));
		}
	} catch (error) {
		dispatch(AlertAction.Error(error));
	}
}

// BUG-214: 사이트 이름(newSiteName)은 전달받지 않는다. 서버가 newSiteId 로 조회해 채운다.
// 클라이언트가 이름을 다시 보내도 서버가 무시하고 warn 을 남긴다 — 여기서 인자를 추가하지 말 것.
const UpdateProductSite = (sn, nowSiteId, newSiteId) => async (dispatch) => {
	dispatch({ type: ProductConstant.LOADING });
	try {
		const data = {
			who: JSON.parse(localStorage.getItem('user')).adminid,
			type: 'updateSite',
			data: { nowSiteId: nowSiteId, newSiteId: newSiteId },
		};
		const ret = await axios.post(AppConfig.API_SERVER_PATH + '/product/' + sn, data, JWT());
		if (ret.data.status == 'success') {
			dispatch(AlertAction.Success(t('common.message.success.saved')));
			dispatch({ type: ProductConstant.UPDATE_PRODUCTINFO, product: ret.data.data });
		} else {
			dispatch(AlertAction.Error(ret.data));
		}
	} catch (error) {
		dispatch(AlertAction.Error(error));
	}
	dispatch({ type: ProductConstant.LOADED });
};

const RequestErrorLogFile = (sn, errId) => async (dispatch) => {
	dispatch({ type: ProductConstant.LOADING });
	try {
		const data = {
			who: JSON.parse(localStorage.getItem('user')).adminid,
			type: 'requestErrorLogs',
			data: { errorId: errId },
		};
		const ret = await axios.post(AppConfig.API_SERVER_PATH + '/product/' + sn, data, JWT());
		if (ret.data.status == 'success') {
			dispatch({ type: ProductConstant.UPDATE_PRODUCTINFO, product: ret.data.data });
		} else {
			dispatch(AlertAction.Error(ret.data));
		}
	} catch (error) {
		dispatch(AlertAction.Error(error));
	}
	dispatch({ type: ProductConstant.LOADED });
};

// FEAT-015: 에러 메일 예외 등록
const AddErrorMailException = (sn, errorCode, description) => async (dispatch) => {
	dispatch({ type: ProductConstant.LOADING });
	try {
		const user = JSON.parse(localStorage.getItem('user') || '{}');
		const data = {
			who: user.adminid,
			type: 'addErrorMailException',
			data: { errorCode, description: description || '' },
		};
		const ret = await axios.post(AppConfig.API_SERVER_PATH + '/product/' + sn, data, JWT());
		if (ret.data.status === 'success') {
			dispatch(AlertAction.Success(t('common.message.success.saved')));
			dispatch({ type: ProductConstant.LOADED });
			return ret.data.data;
		} else {
			dispatch(AlertAction.Error(ret.data));
		}
	} catch (error) {
		dispatch(AlertAction.Error(error));
	}
	dispatch({ type: ProductConstant.LOADED });
};

// FEAT-015: 에러 메일 예외 해제
const RemoveErrorMailException = (sn, errorCode) => async (dispatch) => {
	dispatch({ type: ProductConstant.LOADING });
	try {
		const user = JSON.parse(localStorage.getItem('user') || '{}');
		const data = {
			who: user.adminid,
			type: 'removeErrorMailException',
			data: { errorCode },
		};
		const ret = await axios.post(AppConfig.API_SERVER_PATH + '/product/' + sn, data, JWT());
		if (ret.data.status === 'success') {
			dispatch(AlertAction.Success(t('common.message.success.saved')));
			dispatch({ type: ProductConstant.LOADED });
			return ret.data.data;
		} else {
			dispatch(AlertAction.Error(ret.data));
		}
	} catch (error) {
		dispatch(AlertAction.Error(error));
	}
	dispatch({ type: ProductConstant.LOADED });
};

// FEAT-015: 에러 메일 예외 목록 조회 (백그라운드 — LOADING 없음)
const GetErrorMailExceptions = (sn) => async () => {
	try {
		const user = JSON.parse(localStorage.getItem('user') || '{}');
		const data = {
			who: user.adminid,
			type: 'getErrorMailExceptions',
			data: {},
		};
		const ret = await axios.post(AppConfig.API_SERVER_PATH + '/product/' + sn, data, JWT());
		if (ret.data.status === 'success') {
			return ret.data.data || [];
		}
	} catch (error) {
		// silent — 예외 목록 조회 실패 시 빈 배열 반환
	}
	return [];
};

// FEAT-015: 에러 메일 예외 일괄 조회 (AdminErrorList 페이지용, dispatch 불필요 — 직접 반환)
const BatchCheckMailExceptions = (items) => async () => {
	try {
		const user = JSON.parse(localStorage.getItem('user') || '{}');
		const data = {
			who: user.adminid,
			type: 'batchCheckMailExceptions',
			data: { items },
		};
		const ret = await axios.post(AppConfig.API_SERVER_PATH + '/product', data, JWT());
		if (ret.data.status === 'success') {
			return ret.data.data || [];
		}
	} catch (error) {
		console.warn('[BatchCheckMailExceptions] Failed:', error.message);
	}
	return [];
};

const BulkUpdateProductInfo = (sns, productInfo) => async (dispatch) => {
	dispatch({ type: ProductConstant.LOADING });
	try {
		const data = {
			who: JSON.parse(localStorage.getItem('user')).adminid,
			type: 'updatebulk',
			list: sns,
			data: productInfo,
		};
		const ret = await axios.post(AppConfig.API_SERVER_PATH + '/product', data, JWT());
		if (ret.data.status == 'success') {
			const list = ret.data.data?.list;
			dispatch({ type: ProductConstant.BULKUPDATE_PRODUCTINFO, products: list });
			// IMP-466: 권한 drop 판정(요청값 vs 응답값 비교)은 여기서 다시 하지 않는다.
			// BE 응답 계약 meta.dropped 를 전역 axios 인터셉터(src/lib/axiosSetup.js)가 이미 감지해
			// 19개 언어 안내 토스트를 띄운다 — 판정 지점을 그 1곳으로 통일한다(CLAUDE.md §8, 중복 판정 금지).
			// 이 자리의 하드코딩 영어 ErrorMsg 는 19개 언어 사용자에게 그대로 노출되고 있었다.
			// BUG-192/193 의 무음 성공 방지 목적은 폐기가 아니라 전역 계층으로 이관된 것이다.
			dispatch(AlertAction.Success(t('common.message.success.saved')));
		} else {
			dispatch(AlertAction.Error(ret.data));
		}
	} catch (error) {
		dispatch(AlertAction.Error(error));
	}
	dispatch({ type: ProductConstant.LOADED });
};

const BulkUpdateEachProductInfo = (list) => async (dispatch) => {
	dispatch({ type: ProductConstant.LOADING });
	let result;
	try {
		const data = {
			who: JSON.parse(localStorage.getItem('user')).adminid,
			type: 'updateeachbulk',
			list: list,
		};
		// BUG-195: 전역 안내를 opt-out(`skipGlobalDropNotice`) 하지 않는다 — 그 플래그는
		// axiosSetup.js#noticeDroppedFields 에서 console.warn 보다 **앞서** return 하므로 토스트만이
		// 아니라 로그까지 끊는다. 가져오기는 청크 중간에 실패해 완료 화면에 못 가는 경우가 있어,
		// 화면 안내만 남기면 그 순간 drop 이 완전 무음이 된다(CLAUDE.md 규칙 7).
		const ret = await axios.post(AppConfig.API_SERVER_PATH + '/product', data, JWT());
		if (ret.data.status == 'success') {
			const updatedList = ret.data?.data?.list ?? [];
			const dropped = Array.isArray(ret.data?.meta?.dropped) ? ret.data.meta.dropped : [];
			dispatch({ type: ProductConstant.BULKUPDATE_PRODUCTINFO, products: updatedList });
			result = { status: 'success', data: updatedList, dropped };
		} else {
			dispatch(AlertAction.Error(ret.data));
			result = { status: 'error', err: ret.data.err };
		}
	} catch (error) {
		dispatch(AlertAction.Error(error));
		result = { status: 'error', err: error?.message || 'Failed to bulk update product info.' };
	}
	dispatch({ type: ProductConstant.LOADED });
	return result;
};

const BulkUpdateEachProductTenYearsWarranty = (list) => async (dispatch) => {
	dispatch({ type: ProductConstant.LOADING });
	let result;
	try {
		const data = {
			who: JSON.parse(localStorage.getItem('user')).adminid,
			type: 'tenyears',
			sn: list,
		};
		const ret = await axios.post(AppConfig.API_SERVER_PATH + '/set-tenyearswarranty', data, JWT());
		if (ret.data.status == 'success') {
			dispatch({ type: ProductConstant.LOADED });
			result = { status: 'success', data: ret.data.data };
		} else {
			dispatch(AlertAction.Error(ret.data));
			result = { status: 'error', err: ret.data.err };
		}
	} catch (error) {
		dispatch(AlertAction.Error(error));
		result = { status: 'error', err: error?.message || 'Failed to update ten years warranty.' };
	}
	dispatch({ type: ProductConstant.LOADED });
	return result;
};

const UpdateProductInfo = (sn, productInfo) => async (dispatch) => {
	let ok = false;
	dispatch({ type: ProductConstant.LOADING });
	try {
		const data = {
			who: JSON.parse(localStorage.getItem('user')).adminid,
			type: 'update',
			data: productInfo,
		};

		if (productInfo.hasOwnProperty("companyId")) {
			const codeList = store.getState().RayCodeReducer?.items || [];
			const warrantyType = resolveWarrantyType(productInfo.model, codeList);
			const warrantyRet = await RayDataAction.SetWarranty(sn, "HQ", warrantyType);
			if (warrantyRet?.status !== 'success') {
				console.warn('[ProductAction.UpdateProductInfo] SetWarranty failed (continuing product update)', {
					handler: 'ProductAction.UpdateProductInfo',
					target: sn,
					reason: 'SetWarranty returned non-success',
				});
			}
		}

		const ret = await axios.post(AppConfig.API_SERVER_PATH + '/product/' + sn, data, JWT());
		if (ret.data.status == 'success') {
			dispatch({ type: ProductConstant.UPDATE_PRODUCTINFO, product: ret.data.data });
			// IMP-466: 권한 drop 판정(요청값 vs 응답값 비교)은 여기서 다시 하지 않는다.
			// BE 응답 계약 meta.dropped 를 전역 axios 인터셉터(src/lib/axiosSetup.js)가 이미 감지해
			// 19개 언어 안내 토스트를 띄운다 — 판정 지점을 그 1곳으로 통일한다(CLAUDE.md §8, 중복 판정 금지).
			// 이 자리의 하드코딩 영어 ErrorMsg 는 19개 언어 사용자에게 그대로 노출되고 있었다.
			// BUG-192/193 의 무음 성공 방지 목적은 폐기가 아니라 전역 계층으로 이관된 것이다.
			dispatch(AlertAction.Success(t('common.message.success.saved')));
			ok = true;
		} else {
			dispatch(AlertAction.Error(ret.data));
		}
	} catch (error) {
		dispatch(AlertAction.Error(error));
	}
	dispatch({ type: ProductConstant.LOADED });
	return ok;
};

// options.silent: 여러 건을 반복 호출하는 대량 경로(AdminErrorList 일괄 종료)가 건별 성공 토스트를 끌 때 쓴다(기본 false).
const CloseProductError = (sn, errInfo, extra, options) => async (dispatch) => {
	dispatch({ type: ProductConstant.ERR_LOADING });
	try {
		const data = {
			who: JSON.parse(localStorage.getItem('user')).adminid,
			type: 'closeError',
			data: errInfo,
			extra: extra,
		};
		const ret = await axios.post(AppConfig.API_SERVER_PATH + '/product/' + sn, data, JWT());
		if (ret.data.status == 'success') {
			if (!options?.silent) dispatch(AlertAction.Success(t('common.message.success.saved')));
			dispatch({ type: ProductConstant.UPDATE_PRODUCTERRORINFO, result: ret.data.data, isClose: errInfo.hasOwnProperty("closer") });
			dispatch({ type: ProgramConstant.UPDATE_PRODUCTERRORINFO, result: ret.data.data, isClose: errInfo.hasOwnProperty("closer") });
		} else {
			dispatch(AlertAction.Error(ret.data));
		}
	} catch (error) {
		dispatch(AlertAction.Error(error));
	}
	dispatch({ type: ProductConstant.ERR_LOADED });
};

const UpdateProductError = (sn, errInfo) => async (dispatch) => {
	dispatch({ type: ProductConstant.ERR_LOADING });
	try {
		const data = {
			who: JSON.parse(localStorage.getItem('user')).adminid,
			type: 'updateError',
			data: errInfo,
		};
		const ret = await axios.post(AppConfig.API_SERVER_PATH + '/product/' + sn, data, JWT());
		if (ret.data.status == 'success') {
			dispatch({ type: ProductConstant.UPDATE_PRODUCTERRORINFO, result: ret.data.data, isClose: errInfo.hasOwnProperty("closer") });
			dispatch({ type: ProgramConstant.UPDATE_PRODUCTERRORINFO, result: ret.data.data, isClose: errInfo.hasOwnProperty("closer") });
		} else {
			dispatch(AlertAction.Error(ret.data));
		}
	} catch (error) {
		dispatch(AlertAction.Error(error));
	}
	dispatch({ type: ProductConstant.ERR_LOADED });
};

const RegistProductInfo = (productInfo) => async (dispatch) => {
	dispatch({ type: ProductConstant.LOADING });
	try {
		const data = {
			who: JSON.parse(localStorage.getItem('user')).adminid,
			type: 'create',
			data: productInfo,
		};

		const ret = await axios.post(AppConfig.API_SERVER_PATH + '/product', data, JWT());
		if (ret.data.status == 'success') {
			dispatch(AlertAction.Success(t('common.message.success.saved')));
			dispatch({ type: ProductConstant.REGIST_PRODUCTINFO, product: ret.data.data });
		} else {
			dispatch(AlertAction.Error(ret.data));
		}
	} catch (error) {
		dispatch(AlertAction.Error(error));
	}
	dispatch({ type: ProductConstant.LOADED });
};

const DeleteProduct = (sn) => async (dispatch) => {
	dispatch({ type: ProductConstant.LOADING });
	try {
		const data = {
			who: JSON.parse(localStorage.getItem('user')).adminid,
			type: 'delete',
		};
		const ret = await axios.post(AppConfig.API_SERVER_PATH + '/product/' + sn, data, JWT());
		if (ret.data.status == 'success') {
			dispatch(AlertAction.Success(t('common.message.deleted')));
			dispatch({ type: ProductConstant.DELETE_PRODUCT, delproductid: sn });
		} else {
			dispatch(AlertAction.Error(ret.data));
		}
	} catch (error) {
		dispatch(AlertAction.Error(error));
	}
	dispatch({ type: ProductConstant.LOADED });
};

const ClearUpdateResult = () => (dispatch) => {
	dispatch({ type: ProductConstant.CLEAR_UPDATERES });
};

const ChangeSN = async (sn, body) => {
	try {
		const data = {
			type: "changesn",
			who: JSON.parse(localStorage.getItem('user')).adminid,
			data: body
		}
		return await axios.post(AppConfig.API_SERVER_PATH + '/product/' + sn, data, JWT());
	} catch (error) {
		console.error("ChangeSN error:", error);
		return null;
	}
}

const GetProductErrorId = async (sn, producterrorCodeId) => {
	try {
		const ret = await axios.get(AppConfig.API_SERVER_PATH + '/product/getproducterrorid/' + sn + "/" + producterrorCodeId, JWT());
		if (ret.data.status == 'success') {
			return ret.data.data;
		}
	} catch (error) {
		console.error("GetProductErrorId error:", error);
	}
	return [];
}

const GetComboList = async () => {
	try {
		const ret = await axios.get(AppConfig.API_SERVER_PATH + '/product/getcombo', JWT());
		if (ret.data.status == 'success') {
			return ret.data.data;
		}
	} catch (error) {
		console.error("GetComboList error:", error);
	}
	return [];
}

const GetProductDirect = async (filter) => {
	try {
		const data = { type: "get", data: filter }
		const ret = await axios.post(AppConfig.API_SERVER_PATH + '/product', data, JWT());
		if (ret.data.status == 'success') {
			return ret.data.data;
		}
	} catch (error) {
		console.error("GetProductDirect error:", error);
	}
	return [];
};

// IMP-313: MySearch product 검색 — lookup-heavy /product → /productv2 (getAllV2, $lookup 없음) 전환. IMP-295/298 패턴.
const GetProductDirectV2 = async (filter) => {
	try {
		const data = { type: "get", data: filter }
		const ret = await axios.post(AppConfig.API_SERVER_PATH + '/productv2', data, JWT());
		if (ret.data.status == 'success') {
			return ret.data.data;
		}
	} catch (error) {
		console.error("GetProductDirectV2 error:", error);
	}
	return [];
};

const GetProductAllLocal = async (filter) => {
	try {
		const data = { type: "get", data: filter }
		// IMP-298: lookup-heavy /product → /productv2 (getAllV2, lookup 없음) 전환 — IMP-295 잔여분
		const ret = await axios.post(AppConfig.API_SERVER_PATH + '/productv2', data, JWT());
		if (ret.data.status == 'success') {
			return ret.data.data
		}
	} catch (error) {
		console.error("GetProductAllLocal error:", error);
	}
	return null;
};


const GetProductRecentInstall = (days) => async (dispatch) => {
	dispatch({ type: ProductConstant.LOADING });
	const showmodel = store.getState().ProgramReducer.showmodel;
	const aggregate = [];
	const fin = moment.utc(moment().utc()).add(-1 * days, 'days').unix() * 1000;
	if(showmodel[0] !== ''){
		aggregate.push({
			'$match' : {
				'model' : { '$in' : showmodel} ,
				'installedDate': { '$gte': fin },
				'siteId': { '$ne': '' }
			}
		});
	}else{
		aggregate.push({
			'$match' : {
				'installedDate': { '$gte': fin },
				'siteId': { '$ne': '' }
			}
		});
	}
	aggregate.push({
		'$project' : {
			'sn': 1,
			'option': 1,
			'doa' : 1,
			'dim' : 1,
		}
	});
	const data = {
		data : { type: "product", aggregate }
	}
	try {
		const ret = await axios.post(AppConfig.API_SERVER_PATH + '/q', data, JWT());
		if (ret.data.status == 'success') {
			dispatch({ type: ProgramConstant.SET_RECENTINSTALL, list: ret.data.data });
		} else {
			dispatch(AlertAction.Error(ret.data));
		}
	} catch (error) {
		dispatch(AlertAction.ErrorMsg("Failed to get recent installations."));
	}
	dispatch({ type: ProductConstant.LOADED });
};

const GetProductActiveCount = (_days) => async (dispatch) => {
	dispatch({ type: ProductConstant.LOADING });
	try {
		const data = { type: "getcount" }
		const ret = await axios.post(AppConfig.API_SERVER_PATH + '/product', data, JWT());

		console.log('ret',ret);

		if (ret.data.status == 'success') {
			dispatch({ type: ProgramConstant.SET_TOTALPRDCOUNT, data: ret.data.data });
		} else {
			dispatch(AlertAction.Error(ret.data));
		}
	} catch (error) {
		dispatch(AlertAction.ErrorMsg("Failed to get product count."));
	}
	dispatch({ type: ProductConstant.LOADED });
};

const Comment = (prodcutId, type, commentData) => async (dispatch) => {
	dispatch({ type: ProductConstant.LOADING });
	try {
		const data = {
			who: JSON.parse(localStorage.getItem('user')).adminid,
			type: type,
			data: commentData
		};
		const ret = await axios.post(AppConfig.API_SERVER_PATH + '/product/' + prodcutId, data, JWT());
		if (ret.data.status == 'success') {
			dispatch(AlertAction.Success(t(type === 'delComment' ? 'common.message.deleted' : 'common.message.success.saved')));
			dispatch({
				type: type == "ADD" ?
					ProductConstant.UPDATE_PRODUCTINFO :
					ProductConstant.UPDATE_PRODUCTINFO, product: ret.data.data
			});
		} else {
			dispatch(AlertAction.Error(ret.data));
		}
	} catch (error) {
		dispatch(AlertAction.Error(error));
	}
	dispatch({ type: ProductConstant.LOADED });
};

const GetErrorListLocal = async (filter) => {
	try {
		const data = {
			type: "geterrorlists",
			data: { ...filter }
		}
		const ret = await axios.post(AppConfig.API_SERVER_PATH + '/product', data, JWT());
		if (ret.data.status == 'success') {
			return ret.data.data;
		}
	} catch (error) {
		console.error("GetErrorListLocal error:", error);
	}
	return null;
};

// SEC-051: updatetransferbulk 는 권한/값 검증 실패를 403·400 으로 구분해 응답한다(axios reject).
//   기존 catch 는 원인과 무관하게 한 문구로 뭉개 사용자가 무엇을 고쳐야 할지 알 수 없었다.
// PR #526 리뷰 Minor: OUT_OF_SCOPE 문구가 "전면 no-op" 을 단정하지 않도록 기술한다.
//   BE updatetransferbulk 는 루프 안에서 제품별 스코프를 검사하므로 N번째 실패 전 1~N-1 건이
//   이미 커밋될 수 있다(사전 존재 결함 — BUG-197). 형제 BulkUpdateProductInfo 는 단일
//   updateMany 라 "was not changed" 가 사실이므로 그쪽 문구는 그대로 둔다.
const TRANSFER_REASON_MESSAGES = {
	INSUFFICIENT_ROLE: 'Operator transfer requires Super Admin permission.',
	OUT_OF_SCOPE: 'Transfer stopped: you can only transfer products within your own organization. Please reload the list to check which products were applied.',
	INVALID_VALUE: 'Please select a valid operator company before transferring.',
};
const TRANSFER_FALLBACK_MESSAGE = 'Failed to bulk update transfer info.';

// reason 은 서버 제어 문자열이라 `MAP[reason]` 직접 조회 시 'toString' 같은 프로토타입 키가
//   상속 함수(truthy)를 반환한다. hasOwnProperty 로 차단 (IMP-415 와 동일 판정).
const resolveTransferError = (payload) => {
	const reason = payload?.data?.reason;
	return Object.prototype.hasOwnProperty.call(TRANSFER_REASON_MESSAGES, reason)
		? TRANSFER_REASON_MESSAGES[reason]
		: TRANSFER_FALLBACK_MESSAGE;
};

const BulkUpdateTransferInfo = (sns, transferInfo, reason = undefined) => async (dispatch) => {
	dispatch({ type: ProductConstant.LOADING });
	let result;
	try {
		const data = {
			who: JSON.parse(localStorage.getItem('user')).adminid,
			type: 'updatetransfer',
			list: sns,
			data: transferInfo,
		};
		// IMP-475 P4: 사유는 선택 입력 — 공백뿐이면 키 자체를 싣지 않는다(기존 호출 동작 불변).
		const trimmedReason = typeof reason === 'string' ? reason.trim() : '';
		if (trimmedReason) data.reason = trimmedReason;
		const ret = await axios.post(AppConfig.API_SERVER_PATH + '/product', data, JWT());
		if (ret.data.status == 'success') {
			// PR #526 리뷰 Minor: `?.list` 만으로는 undefined 가 reducer 로 흘러가고
			//   ProductReducer 의 BULKUPDATE_PRODUCTINFO 가 `action.products.filter(...)` 를 호출해
			//   dispatch 안에서 throw → 같은 try 의 catch 로 흡수돼 실패 안내가 뜬다.
			//   reducer 계약(배열)을 지켜 방어를 실제로 성립시킨다.
			dispatch({ type: ProductConstant.BULKUPDATE_PRODUCTINFO, products: ret.data.data?.list ?? [] });
			// SEC-051: 성공 안내가 없어 정상 이전도 "무반응" 으로 보였다 (BUG-193 형제 경로와 동일 증상).
			dispatch(AlertAction.Success(t('common.message.success.saved')));
			// BUG-178 형제: 호출부(FE 청크 순차 await)가 성공/실패를 판별하도록 result 반환 계약 유지.
			result = { status: 'success', data: ret.data.data?.list ?? [] };
		} else {
			dispatch(AlertAction.Error(ret.data));
			result = { status: 'error', err: ret.data.err };
		}
	} catch (error) {
		console.warn('[ProductAction.BulkUpdateTransferInfo] operator transfer failed', {
			handler: 'ProductAction.BulkUpdateTransferInfo',
			targetCount: sns?.length,
			// §7 target identity — 어느 operator 로 이전하려다 실패했는지 남긴다.
			//   (IMP-466 이전에는 형제 경로 BulkUpdateProductInfo 의 requestedCompanyId 와 같은 역할이었으나,
			//    그 판정은 전역 meta.dropped 계층으로 이관되며 제거됐다.)
			//   비-string 은 값 대신 타입만 남긴다(BE warn 규약과 동일).
			requestedOperator: typeof transferInfo === 'string' ? transferInfo.slice(0, 64) : typeof transferInfo,
			status: error?.response?.status,
			reason: error?.response?.data?.data?.reason,
		});
		dispatch(AlertAction.ErrorMsg(resolveTransferError(error?.response?.data)));
		result = { status: 'error', err: error?.message || 'Failed to bulk update transfer info.' };
	}
	dispatch({ type: ProductConstant.LOADED });
	return result;
};

const UpdateProductHistoryReport = (sn, productHistoryInfo) => async (dispatch) => {
	dispatch({ type: ProductConstant.LOADING });
	try {
		const data = {
			who: JSON.parse(localStorage.getItem('user')).adminid,
			type: 'updateProductHistory',
			data: productHistoryInfo,
		};
		const ret = await axios.post(AppConfig.API_SERVER_PATH + '/product/' + sn, data, JWT());
		if (ret.data.status == 'success') {
			dispatch(AlertAction.Success(t('common.message.success.saved')));
			dispatch({ type: ProductConstant.UPDATE_PRODUCTINFO, product: ret.data.data });
		} else {
			dispatch(AlertAction.Error(ret.data));
		}
	} catch (error) {
		dispatch(AlertAction.Error(error));
	}
	dispatch({ type: ProductConstant.LOADED });
};

const GetReducer = (state) => {
	return state.ProductReducer;
};

const SetProductWarranty = (sn, data) => async (dispatch) => {
	try {
		const ret = await axios.post(AppConfig.API_SERVER_PATH + '/product/' + sn, {
			type: 'setproductwarranty',
			data,
			who: JSON.parse(localStorage.getItem('user')).adminid
		}, JWT());

		if (ret.data.status == 'success') {
			dispatch({ type: ProductConstant.GET_PRODUCT, product: ret.data.data });
		} else {
			dispatch(AlertAction.Error(ret.data));
		}
	} catch (error) {
		dispatch(AlertAction.Error(error));
	}
}

const RegistProductSiteByUser = async (data) => {
	try {
		const ret = await axios.post(AppConfig.API_SERVER_PATH + '/siteregistbyuser', { data });
		return ret;
	} catch (error) {
		console.error("RegistProductSiteByUser error:", error);
		return null;
	}
}

const GetProductBySN = async (sn) => {
	try {
		const ret = await axios.get(AppConfig.API_SERVER_PATH + '/product/' + sn, JWT());
		if (ret.data.status == 'success') {
			return ret.data.data;
		}
	} catch (error) {
		console.error("GetProductBySN error:", error);
	}
	return [];
};

const GetProductBySiteId = (siteId, prdtype) => async (dispatch) => {
	dispatch({ type: ProductConstant.LOADING });
	const aggregate = [];
		aggregate.push({
			'$match' : {
				'siteId': siteId,
				'prdtype': prdtype,
        'isDel': false
			}
		});
	aggregate.push({
		'$project' : {
			'sn': 1,
			'option': 1,
			'prdtype': 1,
      'siteId': 1,
      'sitename': 1,
      'model': 1,
      'option': 1,
		}
	});
	const data = {
		data : { type: "product", aggregate }
	}
	try {
		const ret = await axios.post(AppConfig.API_SERVER_PATH + '/q', data, JWT());
		if (ret.data.status == 'success') {
			dispatch({ type: ProductConstant.GET_PRODUCTS_BY_SITE_ID, item: ret.data.data });
		} else {
			dispatch(AlertAction.Error(ret.data));
		}
	} catch (error) {
		dispatch(AlertAction.ErrorMsg("Failed to get products by site."));
	}
	dispatch({ type: ProductConstant.LOADED });
};

const saveProductRlog = (logtype,list) => async (dispatch) => {
	dispatch({ type: ProductConstant.LOADING });
	try {
		const data = {
			type: 'saverlog',
			data: {
				adminid: JSON.parse(localStorage.getItem('user')).adminid,
				logtype: logtype,
				list: list,
			}
		};
		const ret = await axios.post(AppConfig.API_SERVER_PATH + '/product', data, JWT());
		if (ret.data.status == 'success') {
			dispatch({ type: ProductConstant.SAVE_PRODUCT_RLOG, rlog: ret.data.data });
		} else {
			dispatch(AlertAction.Error(ret.data));
		}
	} catch (error) {
		dispatch(AlertAction.Error(error));
	}
	dispatch({ type: ProductConstant.LOADED });
};

const getProductRlog = (logtype) => async (dispatch) => {
	dispatch({ type: ProductConstant.LOADING });
	try {
		const data = {
			type: 'getrlog',
			data: {
				logtype: logtype
			}
		};
		const ret = await axios.post(AppConfig.API_SERVER_PATH + '/product', data, JWT());
		if (ret.data.status == 'success') {
			dispatch({ type: ProductConstant.GET_PRODUCT_RLOG, rlogs: ret.data.data });
		} else {
			dispatch(AlertAction.Error(ret.data));
		}
	} catch (error) {
		dispatch(AlertAction.ErrorMsg("Failed to get product rlog."));
	}
	dispatch({ type: ProductConstant.LOADED });
};

export const ProductAction = {
	GetProductAll,
	GetProductAllV2,
	GetProductAllStock,
	GetFavProductAll,
	UpdateProductSite,
	GetProductDirect,
	GetProductDirectV2,
	GetProduct,
	UpdateProductInfo,
	RegistProductInfo,
	ClearUpdateResult,
	GetProductErrorId,
	RequestErrorLogFile,
	DeleteProduct,
	GetReducer,
	GetComboList,
	GetErrors,
	GetErrorCount,
	GetProductLocal,
	UpdateProductError,
	GetStatistics,
	GetSavedFilters,
	CloseProductError,
	SaveStatisticsFilter,
	DeleteSavedFilter,
	GetProductRecentInstall,
	GetProductActiveCount,
	BulkUpdateProductInfo,
	BulkUpdateEachProductInfo,
	Comment,
	GetErrorList,
	UpdateProductWarranty,
	GetProductAllLocal,
	GetErrorListLocal,
	GetProductOld,
	GetAllErrorList,
	ChangeSN,
	BulkUpdateTransferInfo,
	UpdateProductHistoryReport,
	SetProductWarranty,
	AddExtendedWarranty,
	DeleteExtendedWarranty,
	UpdateExtendedWarranty,
	RegistProductSiteByUser,
	BulkUpdateEachProductTenYearsWarranty,
	GetProductAcq,
	GetProductAcqChart,
	GetProductBySN,
  GetProductBySiteId,
  GetProductDia,
  GetProductHistory,
  saveProductRlog,
  getProductRlog,
  AddErrorMailException,
  RemoveErrorMailException,
  GetErrorMailExceptions,
  BatchCheckMailExceptions
};
